import loadable from '@loadable/component'

export default [
  {
    path: '/CoinAgencyCollectSalary/clientList',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-CoinAgencyCollectSalary-clientList" */ '~/pages/CoinAgencyCollectSalary/pages/clientList'
        )
    ),
  },
  {
    path: '/CoinAgencyCollectSalary/client',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-CoinAgencyCollectSalary-client" */ '~/pages/CoinAgencyCollectSalary/pages/client'
        )
    ),
  },
  {
    // 收款方式列表
    path: '/CoinAgencyCollectSalary/Payment/list',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-CoinAgencyCollectSalary-Payment-list-index" */ '~/pages/CoinAgencyCollectSalary/pages/Payment-list'
        )
    ),
  },
  {
    // 收款方式表单
    path: '/CoinAgencyCollectSalary/Payment/form',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-CoinAgencyCollectSalary-Payment-form-index" */ '~/pages/CoinAgencyCollectSalary/pages/Payment-form'
        )
    ),
  },
  {
    path: '/CoinAgencyCollectSalary/record',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-CoinAgencyCollectSalary-record" */ '~/pages/CoinAgencyCollectSalary/pages/record'
        )
    ),
  },
]
